import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store";
import btranslate from "@/mixins/btranslate.js";
import toFormData from "@/mixins/formData.js";
import api from "@/mixins/api.js";
Vue.mixin(api);
//import './registerServiceWorker'
Vue.mixin(btranslate);
Vue.mixin(toFormData);

Vue.config.productionTip = false;

new Vue({
    vuetify,
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
